/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarketListQuery
 */
export interface MarketListQuery {
    /**
     * 
     * @type {string}
     * @memberof MarketListQuery
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarketListQuery
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MarketListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketListQuery
     */
    limit?: number | null;
}

export function MarketListQueryFromJSON(json: any): MarketListQuery {
    return MarketListQueryFromJSONTyped(json, false);
}

export function MarketListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MarketListQueryToJSON(value?: MarketListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'showNonEffective': value.showNonEffective,
        'offset': value.offset,
        'limit': value.limit,
    };
}


